<template>
  <div v-if="currentAccessLevel == 'admin' || currentAccessLevel == 'poweruser'">
    <div class="configure-container">
      <div class="configure-title-section">
        <div class="configure-title">Configuration</div>
      </div>
      <div class="configure-view-section" :style="{height: `${maxHeight - 214}px`}">
          <div class="configure-menu">
            <div class="configure-box">
                  <div style="width: 140px;"> <img class="conf-img" src="../assets/img/programs.svg" alt="metric image" /> </div>
                <div class="menu-item">
                    <div class="menu-title">
                        Programs
                    </div>
                    <div class="menu-discription">
                        Edit or delete programs. Mark them as active or in-active.
                    </div>
                    <div class="navigate-menu-item" @click="handleNavigation('programsConfig')">
                        CONFIGURE
                    </div>
                </div>
            </div>
            <div class="configure-box">
                <div style="width: 140px;"> <img class="conf-img" src="../assets/img/metrics.svg" alt="metric image" />  </div>
                <div class="menu-item">
                    <div class="menu-title">
                        Metrics
                    </div>
                    <div class="menu-discription">
                        Edit category or set decimal rules. Mark them as active or in-active.
                    </div>
                    <div class="navigate-menu-item" @click="handleNavigation('metricConf')">
                        CONFIGURE
                    </div>
                </div>
            </div>
            <div class="configure-box" >
                  <div style="width: 140px;"> <img class="conf-img" src="../assets/img/targets.svg" alt="metric image" />  </div>
                <div class="menu-item">
                    <div class="menu-title" style="margin-right:1000px;">
                        Targets
                    </div>
                    <div class="menu-discription">
                        Edit metric target.
                    </div>
                    <div class="navigate-menu-item" style="margin-right:820px;" @click="handleNavigation('targetsConfig')">
                        CONFIGURE
                    </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Configuration",
  computed: {
        ...mapGetters(['isLoggedIn','currentUserEmail','currentUserName','currentUserGroups','currentAccessLevel']),
        accessLevel: function(){
            console.log(`Current user groups from Configuration. ${this.currentUserGroups}`)
            if(String(this.currentUserGroups).toLowerCase().indexOf('admin')>-1){
                return "admin"
            } else if(String(this.currentUserGroups).toLowerCase().indexOf('poweruser')>-1) {
                return "poweruser"
            } else if(String(this.currentUserGroups).toLowerCase().indexOf('readonly')>-1) {
                return "readonly"
            } else {
                return "unknown"
            }
        }
  },
  methods: {
      handleNavigation(childRouteName) {
            this.$router.push({name: childRouteName})
      }
  },
  data: function() {
    return {
      maxHeight: innerHeight,
      test: "I am from Configuration"
    };
  }
};
</script>

<style scoped>
.conf-img {
    position: relative;
    top: -38px;
}
.menu-item {
    margin-left: 20px;
}
.menu-title {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 12px;
}
.menu-discription {
    margin-bottom: 6px;
    color: #333333;
    height: 65px;
}
.navigate-menu-item {
    color: rgb(43, 119, 155);
    cursor: pointer;
    padding: 3px 10px;
    text-align: end;
    font-weight: bold;
}
.configure-container {
  font-family: Arial;
  font-size: 16px;
  height: 100%;
}
.configure-title-section {
  top: 60px;
  left: 0px;
  width: 100%;
  height: 130px;
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.configure-title {
  margin-left: 28px;
  font-size: 26px;
  font-weight: 300;
}

.configure-view-section {
  background-color: #eeeeee;
  margin: 0;
  padding: 0;
  padding-top: 24px;
  padding-left: 24px;
  padding-right: 24px;
  height: 82vh;
}

.configure-menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.configure-box{
    width: 400px;
    padding: 10px 20px;
    height: 165px;
    margin-right: 20px;
    box-shadow: 5px 6px 10px 0px #ccc;
    background-color: #ffffff;
    font-size: 14px;
    float: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
}
</style>
